import { Pipe, PipeTransform } from '@angular/core';
import { Router } from '@angular/router';
import { LabelService } from '../../framework/labels/services/label.service';
import { map, Observable } from 'rxjs';

@Pipe({
  name: 'publicLabel'
})
export class PublicLabelPipe implements PipeTransform {

  constructor(
    private _labelService: LabelService,
    private _router: Router
  ) { }

  transform(label: string, context?: string): Observable<string> {
    label = label.toLowerCase();
    context = context?.toLowerCase();

    const queryParams = this._router.parseUrl(this._router.url).queryParamMap;
    const languageIdValue = queryParams.get('languageId') ?? queryParams.get('lang');
    const languageId = Number(languageIdValue);
    const validLanguageId = Number.isInteger(languageId) && languageId > 0
      ? languageId
      : undefined;

    return this._labelService.getPublicCandidateLabel(label, context, validLanguageId).pipe(map(e => e.labelText));
  }

}
